import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthServerProvider } from '../../core/auth/auth-jwt.service';
import { AppConfiguration } from '../../core/models/app-configuration.model';

/**
 * Http Interceptor class that add access token to any request that requires it
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly oauthServerProvider: AuthServerProvider,
    private readonly appConfig: AppConfiguration
  ) { }

  /**
   * Interceptor that add bearer token to requests
   * @param request The http request
   * @param next used for binding to http request stream
   */
  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (!request?.url
      || (request.url.startsWith('http')
        && !(this.appConfig.serverApiUrl
          && request.url.startsWith(this.appConfig.serverApiUrl)))
    ) {
      return next.handle(request);
    }

    const token = this.oauthServerProvider.getToken();
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return next.handle(request);
  }
}
